import React from 'react';
import styled from 'styled-components';

import Cifra from './Cifra';

class Cifra2 extends React.Component {
  render() {
    const Doble = styled.div`
    margin: 1em 0 1em 0;
    @media (min-width: 768px) {
    display: flex;
    justify-content: space-between;
    &>div {
      width: 45%;
    }
  }
  `;

    return (
      <Doble>
        <Cifra numero={this.props.numero1} clave={this.props.clave1}/>
        <Cifra numero={this.props.numero2} clave={this.props.clave2}/>
      </Doble>
    );
  }
}

export default Cifra2;



// WEBPACK FOOTER //
// ./src/components/Cifra2.js